import PicabooConstants from '../common/PicabooConstants';
import StandardLanscapeImage from '../public/images/products/StandardLandscape.jpg';
import StandardPortraitImage from '../public/images/products/StandardPortrait.jpg';
import SmallSquareImage from '../public/images/products/SmallSquare.jpg';
import MiniSquareImage from '../public/images/products/MiniSquare.png';
import LargeLandscapeImage from '../public/images/products/LargeLandscape.jpg';
import LargeSquareImage from '../public/images/products/LargeSquare.jpg';
import PocketNotebookImage from '../public/images/products/PocketNotebook.jpg';
import LargeNotebookImage from '../public/images/products/LargeNotebook.jpg';
import StandardPortraitNotebookImage from '../public/images/products/StandardPortraitNotebook.jpg';
import Papertypes_png from '../public/images/bookoptions/Papertypes.png';
import Covertypes_png from '../public/images/bookoptions/Covertypes.png';
import Hardcover_Dustjacket from '../public/images/bookoptions/Hardcover_Dustjacket.jpg';
import Hardcover_Imagewrap from '../public/images/bookoptions/Hardcover_Imagewrap.jpg';
import Softcover from '../public/images/bookoptions/Softcover.jpg';
import Notebook_Covertypes from '../public/images/bookoptions/Notebook_Covertypes.png';
import Notebook_Hardcover_Dustjacket from '../public/images/bookoptions/Notebook_Hardcover_Dustjacket.jpg';
import Notebook_Hardcover_Imagewrap from '../public/images/bookoptions/Notebook_Hardcover_Imagewrap.png';
import Notebook_Softcover from '../public/images/bookoptions/Notebook_Softcover.png';
import Notebook_Wireo from '../public/images/bookoptions/Notebook_Wireo.png';
import Standard_White from '../public/images/bookoptions/Standard_White.png';
import Mohawk_prophoto_pearl from '../public/images/bookoptions/Mohawk_prophoto_pearl.jpg';
import Mohawk_prophoto_pearl_layflat from '../public/images/bookoptions/Mohawk_prophoto_pearl_layflat.jpg';
import Mohawk_superfine_eggshell from '../public/images/bookoptions/Mohawk_superfine_eggshell.jpg';
import Mohawk_superfine_eggshell_layflat from '../public/images/bookoptions/Mohawk_superfine_eggshell_layflat.jpg';
import Premium_Lustre from '../public/images/bookoptions/Premium_Lustre.jpg';
import Premium_Lustre_layflat from '../public/images/bookoptions/premium_lustre_layflat.jpg';
import Premium_Matte from '../public/images/bookoptions/Premium_Matte.jpg';
import Standard from '../public/images/bookoptions/Standard.jpg';
import College_Ruled from '../public/images/bookoptions/College_Ruled.png';
import Dotted_Grid from '../public/images/bookoptions/Dotted_Grid.png';
import Narrow_Ruled from '../public/images/bookoptions/Narrow_Ruled.png';
import Solid_Grid from '../public/images/bookoptions/Solid_Grid.png';
import Wide_Ruled from '../public/images/bookoptions/Wide_Ruled.png';
import Wireo from '../public/images/bookoptions/Wireo.png';
import { invariant } from 'framer-motion';

//PAPER OPTIONS
export const CHOOSE_YOUR_PAPER = 'Choose your Paper';
const MOHAWK_PROPHOTO_PEARL = 'PMPRL';
const MOHAWK_PROPHOTO_PEARL_LAYFLAT = 'LFPRL';
const MOHAWK_SUPERFINE_EGGSHELL = 'PMEGG';
const MOHAWK_SUPERFINE_EGGSHELL_LAYFLAT = 'LFEGG';
const PREMIUM_LUSTRE = 'PPRLS';
const PREMIUM_LUSTRE_LAYFLAT = 'LFPLS';
const PREMIUM_MATTE = 'PPRMT';
const STANDARD = 'PHSTD';
export const STANDARD_WHITE = 'TSTCL';

//COVER OPTIONS
export const CHOOSE_YOUR_COVER = 'Choose your Cover';
export const CHOOSE_YOUR_COVER_NOTEBOOK = 'Choose your Cover Notebook';
const HARDCOVER_IMAGEWRAP_KEY = 'ImageWrap';
const HARDCOVER_DUSTJACKET_KEY = 'DustJacket';
const SOFTCOVER_KEY = 'SoftCover';
export const WIREO_KEY = 'SoftCoverWireo';
const NOTEBOOK_HARDCOVER_DUSTJACKET_KEY = 'Notebook_DustJacket';

export function splitProduct(productPK) {
  let productParts = productPK.split('-');
  return {
    type: productParts[0],
    size: productParts[1],
    cover: productParts[2],
    paper: productParts[3],
  };
}

export function getProductImage(productType) {
  switch (productType) {
    case 'Standard Landscape':
      return StandardLanscapeImage;
    case 'Standard Portrait':
      return StandardPortraitImage;
    case 'Small Square':
      return SmallSquareImage;
    case 'Mini Square':
      return MiniSquareImage;
    case 'Large Landscape':
      return LargeLandscapeImage;
    case 'Large Square':
      return LargeSquareImage;
    case 'Pocket Notebook':
      return PocketNotebookImage;
    case 'Classic Notebook':
      return LargeNotebookImage;
    case 'Standard Notebook':
      return StandardPortraitNotebookImage;
  }
}

export function getCoverImage(key) {
  let coverOpts = getCoverOptions();
  if (coverOpts[key]) {
    return coverOpts[key].image;
  }
  return Covertypes_png;
}

export function getPaperImage(key) {
  let paperOpts = getPaperOptions();
  if (paperOpts[key]) {
    return paperOpts[key].image;
  }
  return Papertypes_png;
}

export function getCoverOptions(subtype) {
  switch (subtype?.pk) {
    case 2: // Cover options for subtype pk=2 (Notebook)
      return [
        { key: CHOOSE_YOUR_COVER_NOTEBOOK, image: Notebook_Covertypes },
        { key: HARDCOVER_IMAGEWRAP_KEY, image: Notebook_Hardcover_Imagewrap },
        { key: HARDCOVER_DUSTJACKET_KEY, image: Notebook_Hardcover_Dustjacket },
        { key: SOFTCOVER_KEY, image: Notebook_Softcover },
        { key: WIREO_KEY, image: Notebook_Wireo },
      ];
    default:
      return [
        { key: CHOOSE_YOUR_COVER, image: Covertypes_png },
        { key: HARDCOVER_IMAGEWRAP_KEY, image: Hardcover_Imagewrap },
        { key: HARDCOVER_DUSTJACKET_KEY, image: Hardcover_Dustjacket },
        { key: SOFTCOVER_KEY, image: Softcover },
        { key: WIREO_KEY, image: Wireo },
      ];
  }
}

export function getDefaultCoverType(t, subtype) {
  const coverOptions = getCoverOptions(subtype);
  const defaultCoverType = {
    label: CHOOSE_YOUR_COVER,
    value: CHOOSE_YOUR_COVER,
    image: coverOptions[0].image,
    description: `EDITORCONTAINER.SIDEPANELCONTAINER.BOOKOPTIONS.cover_types.${coverOptions[0].key}`,
    enabled: true,
  };

  return {
    ...defaultCoverType,
    description: t(defaultCoverType.description).split('|'),
  };
}

export function mapProductPrices(products, pricing) {
  if (!products || !pricing || !pricing.books) return;

  for (const [productKey, product] of Object.entries(products)) {
    //need to find lowest price based on size and cover
    //get all possible pricing
    const matchingProductIds = Object.keys(pricing.books)
      .filter((p) => {
        return pricing.books[p].pk.startsWith(productKey);
      })
      .map((id) => parseInt(id));

    if (matchingProductIds.length === 0) {
      // This can happen if, for example, we have fewer pages than required for some products (like tradebooks)
      console.debug(`Missing pricing information for product: ${productKey}`);
    }

    let prices = [];
    let lowestPrice = 0;
    let lowestPriceString = '';
    //i really hate this
    matchingProductIds.forEach((id) => {
      const priceObject = pricing.books[id];
      const priceKeys = Object.keys(priceObject);
      let normalizedPrice = {};
      priceKeys.forEach((pk) => {
        normalizedPrice[pk] = priceObject[pk];
        if (priceObject[pk].includes('$')) {
          const currentPrice = parseFloat(
            priceObject[pk].substring(priceObject[pk].indexOf('$') + 1),
          );
          if (lowestPrice === 0 || currentPrice < lowestPrice) {
            lowestPrice = currentPrice;
            lowestPriceString = priceObject[pk];
          }
        }
        //get additional page pricing
        const additionalPagePrices = pricing.additional_pages[id];
        if (additionalPagePrices) {
          const addPriceKeys = Object.keys(additionalPagePrices);
          addPriceKeys.forEach((x) => {
            normalizedPrice[`${x}_additional`] = additionalPagePrices[x];
          });
        }
      });
      prices.push(normalizedPrice);
    });

    products[productKey] = {
      ...product,
      lowestPrice: lowestPriceString,
      prices,
      id: matchingProductIds[0],
    };
  }
  return products;
}

// Helper function to get the correct translation key for a cover type based of the subtype
const getTranslationKey = (coverTypeKey, subtype) => {
  if (subtype?.pk === 2 && coverTypeKey === 'DustJacket') {
    return `EDITORCONTAINER.SIDEPANELCONTAINER.BOOKOPTIONS.cover_types.${NOTEBOOK_HARDCOVER_DUSTJACKET_KEY}`;
  }
  return `EDITORCONTAINER.SIDEPANELCONTAINER.BOOKOPTIONS.cover_types.${coverTypeKey}`;
};

export function getCoverOptionsSelect(t, options, products, subtype) {
  const defaultCover = getDefaultCoverType(t, subtype);
  let coverOptsMap = [defaultCover];
  if (!options || options.length === 0) return coverOptsMap;
  let coverTypeKeys = Object.keys(options);

  for (let i = 0; i < coverTypeKeys.length; i++) {
    const coverTypeKey = coverTypeKeys[i];
    const translationKey = getTranslationKey(coverTypeKey, subtype); // Get the translation key
    const description = t(translationKey).split('|');
    const foundCoverType = getCoverOptions(subtype).find(
      (x) => x.key === coverTypeKey,
    );

    let paperOptsMap = [getDefaultPaperType(t, subtype)];
    for (let p = 0; p < options[coverTypeKey].paperTypes.length; p++) {
      const coverPaperType = options[coverTypeKey].paperTypes[p];
      const paperOptions = getPaperOptions(subtype);
      const foundPaperType = paperOptions.find(
        (x) => x.key === coverPaperType.id,
      );
      if (!foundPaperType) continue;

      //get base price and additional page price
      let price = '';
      let additionalPrice = '';
      //a productPK will be on the object if it's a valid paper type
      if (coverPaperType.hasOwnProperty('productPK')) {
        const productParts = splitProduct(coverPaperType.productPK);
        const product = products[`${productParts.type}-${productParts.size}`];
        const priceObj = product.prices?.find(
          (x) =>
            x[coverPaperType.id] !== undefined &&
            x.pk === coverPaperType.productPK,
        );
        if (priceObj) {
          price = priceObj[coverPaperType.id];
          additionalPrice = priceObj[coverPaperType.id + '_additional'];
        }
      }

      let enabled = coverPaperType.enabled;
      if (enabled && price === '') {
        // If enabled, but we have no price, consider it disabled.
        invariant(additionalPrice === '');
        enabled = false;
      }

      const paperDescription = t(
        `EDITORCONTAINER.SIDEPANELCONTAINER.BOOKOPTIONS.paper_types.${coverPaperType.id}`,
      ).split('|');

      const defaultPaperTypePks = [PicabooConstants.PRODUCT_SUBTYPE.TRADEBOOK];
      const defaultPageCount =
        subtype?.pk === 2
          ? PicabooConstants.DEFAULT_TRADEBOOK_PAGE_COUNT
          : PicabooConstants.DEFAULT_BASE_PAGE_COUNT;
      let newPaperOpts = {
        label: paperDescription.shift(),
        value: coverPaperType.id,
        description: paperDescription,
        image: foundPaperType.image,
        id: coverPaperType.id,
        enabled,
        isDisabled: !enabled,
        productPK: coverPaperType.productPK,
        productID: coverPaperType.productID,
        price: 'From ' + price,
        additionalPrice: `for ${defaultPageCount} pages (add ${additionalPrice} per additional page)`,
      };

      if (defaultPaperTypePks.includes(subtype?.pk)) {
        paperOptsMap[0] = newPaperOpts;
        // If it's a default paper type (e.g., pk == 2 for notebooks), update the first paper option
        //load patterns for paper options
        Object.entries(PicabooConstants.PAGE_BACKGROUND_PATTERNS).forEach(
          (entry) => {
            const [key, value] = entry;
            const paperDescription = t(
              `EDITORCONTAINER.SIDEPANELCONTAINER.BOOKOPTIONS.paper_types.${value}`,
            ).split('|');
            if (paperDescription.length > 0) {
              let paperOpt = {
                label: paperDescription.shift(),
                value: value,
                description: paperDescription,
                image: paperOptions.find((x) => x.key === value)?.image,
                id: value,
                enabled: true,
                isDisabled: false,
                productPK: coverPaperType.productPK,
                productID: coverPaperType.productID,
                price: 'From ' + price,
                additionalPrice: `for ${PicabooConstants.DEFAULT_TRADEBOOK_PAGE_COUNT} pages (add ${additionalPrice} per additional page)`,
              };
              if (paperOpt.description.length > 0) paperOptsMap.push(paperOpt);
            }
          },
        );
      } else {
        // For other subtypes, push the new paper option to the array
        paperOptsMap.push(newPaperOpts);
      }
    }

    coverOptsMap.push({
      label: description.shift(),
      value: coverTypeKey,
      default: false,
      description: description,
      image: foundCoverType.image,
      id: coverTypeKey,
      enabled: options[coverTypeKey].enabled,
      isDisabled: !options[coverTypeKey].enabled,
      paperOptions: paperOptsMap,
    });
  }
  //set default if only one enabled cover
  const hasOne = (arr, fn) => {
    const filteredArray = arr.filter(fn);
    const onlyOne = filteredArray.length === 1;
    return {
      hasOne: onlyOne,
      index: onlyOne ? arr.indexOf(filteredArray[0]) : -1,
    };
  };
  const checkOnlyOneCoverEnabled = hasOne(
    coverOptsMap,
    (cover) => cover !== defaultCover && cover.enabled === true,
  );
  if (checkOnlyOneCoverEnabled.hasOne) {
    coverOptsMap[checkOnlyOneCoverEnabled.index].default = true;
  }
  return coverOptsMap;
}

export function getPaperOptions(subtype) {
  console.debug('getPaperOptions', subtype);
  switch (subtype?.pk) {
    case PicabooConstants.PRODUCT_SUBTYPE.TRADEBOOK:
      return [
        { key: STANDARD_WHITE, image: Standard_White },
        {
          key: PicabooConstants.PAGE_BACKGROUND_PATTERNS.COLLEGE_RULE,
          image: College_Ruled,
        },
        {
          key: PicabooConstants.PAGE_BACKGROUND_PATTERNS.NARROW_RULE,
          image: Narrow_Ruled,
        },
        {
          key: PicabooConstants.PAGE_BACKGROUND_PATTERNS.WIDE_RULE,
          image: Wide_Ruled,
        },
        {
          key: PicabooConstants.PAGE_BACKGROUND_PATTERNS.GRID_LINES,
          image: Solid_Grid,
        },
        {
          key: PicabooConstants.PAGE_BACKGROUND_PATTERNS.GRID_DOTS,
          image: Dotted_Grid,
        },
      ];
    default:
      return [
        { key: CHOOSE_YOUR_PAPER, image: Papertypes_png },
        { key: MOHAWK_PROPHOTO_PEARL, image: Mohawk_prophoto_pearl },
        {
          key: MOHAWK_PROPHOTO_PEARL_LAYFLAT,
          image: Mohawk_prophoto_pearl_layflat,
        },
        { key: MOHAWK_SUPERFINE_EGGSHELL, image: Mohawk_superfine_eggshell },
        {
          key: MOHAWK_SUPERFINE_EGGSHELL_LAYFLAT,
          image: Mohawk_superfine_eggshell_layflat,
        },
        { key: PREMIUM_LUSTRE, image: Premium_Lustre },
        { key: PREMIUM_LUSTRE_LAYFLAT, image: Premium_Lustre_layflat },
        { key: PREMIUM_MATTE, image: Premium_Matte },
        { key: STANDARD, image: Standard },
      ];
  }
}

export function getMinimumPageCount(subtype) {
  let minPageCount = PicabooConstants.DEFAULT_BASE_PAGE_COUNT;

  if (subtype?.pk === PicabooConstants.PRODUCT_SUBTYPE.TRADEBOOK) {
    minPageCount = PicabooConstants.MINIMUM_TRADEBOOK_PAGE_COUNT;
  }

  return minPageCount;
}

export function getDefaultPageCount(subtype) {
  let defaultPageCount = PicabooConstants.DEFAULT_BASE_PAGE_COUNT;

  if (subtype?.pk === PicabooConstants.PRODUCT_SUBTYPE.TRADEBOOK) {
    defaultPageCount = PicabooConstants.DEFAULT_TRADEBOOK_PAGE_COUNT;
  }

  return defaultPageCount;
}

export function getDefaultPaperType(t, subtype) {
  let defaultPaperType;
  let description;

  switch (subtype?.pk) {
    case 2: // If subtype.pk == 2 (for notebooks) we have a default paper type
      let paperDescription = t(
        `EDITORCONTAINER.SIDEPANELCONTAINER.BOOKOPTIONS.paper_types.${STANDARD_WHITE}`,
      ).split('|');
      let label = paperDescription[0];
      paperDescription.shift();
      defaultPaperType = {
        label: label,
        value: STANDARD_WHITE,
        id: STANDARD_WHITE,
        heading: label,
        image: getPaperOptions(subtype)[0].image,
        description: paperDescription,
        enabled: true,
      };
      description = defaultPaperType.description;
      break;

    default: // For all other subtypes
      defaultPaperType = {
        label: CHOOSE_YOUR_PAPER,
        heading: `5 ${t('EDITORCONTAINER.SIDEPANELCONTAINER.BOOKOPTIONS.paper_type')}`,
        value: CHOOSE_YOUR_PAPER,
        image: getPaperOptions(subtype)[0].image,
        description: `EDITORCONTAINER.SIDEPANELCONTAINER.BOOKOPTIONS.paper_types.${CHOOSE_YOUR_PAPER}`,
        enabled: true,
      };
      description = t(defaultPaperType.description).split('|');
      break;
  }

  return { ...defaultPaperType, description: description };
}
